import { render } from "./AgendaReunioes.vue?vue&type=template&id=6c8e1e30&scoped=true"
import script from "./AgendaReunioes.vue?vue&type=script&lang=js"
export * from "./AgendaReunioes.vue?vue&type=script&lang=js"

import "./AgendaReunioes.vue?vue&type=style&index=0&id=6c8e1e30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8e1e30"]])

export default __exports__